import { useEffect } from "react";

const OPEN_MENU_SELECTOR =
  ".rs-picker-date-menu.rs-picker-menu, .rs-picker-daterange-menu.rs-picker-menu";

const INSIDE_PICKER_SELECTOR = [
  ".rs-picker-date-menu",
  ".rs-picker-daterange-menu",
  ".rs-calendar",
  ".rs-picker-toolbar",
  ".rs-picker-toggle-active",
  ".rs-picker-open",
  ".custom-date-icon",
  ".custoom-icon-calender",
].join(", ");

/**
 * Close rsuite DatePicker / DateRangePicker menus as soon as the user clicks
 * outside — including during the open animation (rsuite's onOpen waits for
 * onEntered, so default outside-close feels delayed).
 */
export default function useCloseRsuiteDatePickersOnOutsideClick() {
  useEffect(() => {
    const closeOpenMenus = () => {
      if (!document.querySelector(OPEN_MENU_SELECTOR)) return;

      document.dispatchEvent(
        new KeyboardEvent("keyup", {
          key: "Escape",
          code: "Escape",
          keyCode: 27,
          which: 27,
          bubbles: true,
          cancelable: true,
        })
      );
    };

    const handlePointerDown = (event) => {
      if (!document.querySelector(OPEN_MENU_SELECTOR)) return;

      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest(INSIDE_PICKER_SELECTOR)) return;

      closeOpenMenus();
    };

    document.addEventListener("mousedown", handlePointerDown, true);
    document.addEventListener("touchstart", handlePointerDown, { capture: true, passive: true });

    return () => {
      document.removeEventListener("mousedown", handlePointerDown, true);
      document.removeEventListener("touchstart", handlePointerDown, true);
    };
  }, []);
}
